import type { FunctionComponent, HTMLProps, MouseEventHandler } from 'react'
import React from 'react'

import classnames from 'classnames'

import { ArrowDownIcon } from '../Icons/Navigational'
import { NavigationLink } from '../Links/NavigationLink'
import styles from './JumplinksInline.module.scss'

export const JumplinksInline: FunctionComponent<Props> = ({
  items,
  className,
  ...rest
}) => {
  if (!items?.length) {
    return null
  }

  return (
    <ul
      className={classnames(styles.container, className)}
      data-testid="jumplinks-inline"
      {...rest}
    >
      {items.map(({ text, path = '/', onClick }, index) => (
        <li key={`link_${text}_${index}`} className={styles.link}>
          <NavigationLink
            href={path}
            icon={ArrowDownIcon}
            clickHandler={onClick}
            data-testid="jumplinks-inline-link"
            data-which-id="article-anchor-link"
          >
            {text}
          </NavigationLink>
        </li>
      ))}
    </ul>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * An array of links with the text and path supplied as string values, with an optional onClick for
   * implementing smooth scroll behaviour.
   */
  items: Array<{
    text: string
    path?: string
    onClick?: MouseEventHandler<HTMLAnchorElement>
  }>
  className?: string
} & HTMLProps<HTMLUListElement>
